import { FunctionComponent, useCallback } from "react";
import { CarIcon } from "@icons/CarIcon";
import { PersonIcon } from "@icons/PersonIcon";
import { RouteTravelMode } from "@lib/maps/@google/types";
import { selectTravelMode, setTravelMode } from "@store/planRouteReducer";
import { useAppDispatch, useAppSelector } from "@store/store";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
import { TabButton } from "@ui-kit/TabButton/TabButton";

import "./TravelModeToggle.css";
import { useTranslation } from "react-i18next";

const TravelModeToggle: FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const mapTravelMode = useAppSelector(selectTravelMode);
  const { t } = useTranslation();

  const handlePress = useCallback(
    (mode: RouteTravelMode) => () => {
      dispatch(setTravelMode(mode));
    },
    [dispatch],
  );

  return (
    <div className="travel-mode-toggle-component">
      <TabButton
        size="small"
        active={mapTravelMode === RouteTravelMode.DRIVE}
        variant="inverse"
        iconPrefix={
          <CarIcon
            color={
              mapTravelMode === RouteTravelMode.DRIVE
                ? colors.primary60
                : colors.black
            }
            size={12}
          />
        }
        onPress={handlePress(RouteTravelMode.DRIVE)}
        label={t("common.drive")}
      />
      <TabButton
        size="small"
        active={mapTravelMode === RouteTravelMode.WALK}
        variant="inverse"
        iconPrefix={
          <PersonIcon
            color={
              mapTravelMode === RouteTravelMode.WALK
                ? colors.primary60
                : colors.black
            }
            size={12}
          />
        }
        onPress={handlePress(RouteTravelMode.WALK)}
        label={t("common.walk")}
      />
    </div>
  );
};

export { TravelModeToggle };
